var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1633,
    viewBox: "0 0 566.206 369.263",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.619 0h516.968c13.599 0 24.619 11.021 24.619 24.614v320.03c0 13.598-11.021 24.619-24.619 24.619H24.619C11.021 369.263 0 358.242 0 344.644V24.614C0 11.021 11.021 0 24.619 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.686 183.936v159.97c0 9.375 7.695 17.568 17.075 17.568l517.251.016c9.414 0 17.144-8.584 17.144-17.955V183.95",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M352.207 202.51h39.36v106.118h47.08v33.575h-86.44M412.021 202.51h45.538l23.92 41.288 23.16-41.288h45.532l-50.166 74.472v65.221h-37.432v-65.221M38.477 202.51h34.345l37.041 52.866 36.28-52.866h34.726v139.693h-34.726v-89.147l-33.194 44.381h-6.172l-33.955-44.381v89.147H38.477",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.809 272.353c0-41.133 34.727-74.472 77.559-74.472 42.842 0 77.568 33.339 77.568 74.472s-34.727 74.482-77.568 74.482c-42.833 0-77.559-33.349-77.559-74.482",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.712 272.353c0-22.373 16.411-40.518 36.655-40.518 20.254 0 36.665 18.145 36.665 40.518 0 22.383-16.411 40.518-36.665 40.518-20.244 0-36.655-18.135-36.655-40.518",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.439 6.631c-9.805 0-17.754 7.949-17.754 17.754v159.551l551.47.015V24.395c0-9.795-8.081-17.793-17.915-17.793",
    fill: "#00458f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M130.449 25.771h39.361v139.688h-39.361M488.945 25.771h39.746v139.688h-39.746M38.477 25.771h35.629v106.504h46.695v33.184H38.477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.548 25.771h38.975v87.979c0 13.213 11.401 23.926 25.474 23.926 14.063 0 25.469-10.713 25.469-23.926V25.771h38.584l.127 100.713s-.127 43.223-64.18 43.223c-64.063 0-64.448-43.223-64.448-43.223M308.984 179.355l-15.728-17.173c-10.454 5.044-22.266 7.881-34.761 7.881-42.842 0-77.568-33.345-77.568-74.478s34.727-74.482 77.568-74.482c42.837 0 77.563 33.35 77.563 74.482 0 18.628-7.124 35.659-18.896 48.721l19.995 21.152"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278.311 103.721l11.768 11.963c3.076-5.933 5.078-12.773 5.078-20.098 0-22.383-16.416-40.518-36.66-40.518-20.249 0-36.66 18.135-36.66 40.518 0 22.378 16.411 40.518 36.66 40.518 3.525 0 6.846-.645 10.034-1.709l-15.884-17.554",
    fill: "#00458f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo03);
export default __webpack_public_path__ + "static/media/logo03.6abe5819561ca3d6063c2432611946a5.svg";
export { ForwardRef as ReactComponent };